// Widget Scripts
import mainSlideshow from './js/widgets/mainSlideshow.js';
import ticketButton from './js/widgets/ticketButton.js';
import fairEvents from './js/widgets/fairEvents.js';
import cardWidget from './js/widgets/cardWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import gridGallerySmall from './js/widgets/gridGallerySmall.js';
import staticManagedSponsors from './js/widgets/staticManagedSponsors.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    if ($('body').hasClass('eventsMode')) {
      fairEvents();
      cardWidget('fairBigPromos', fairBigPromosOpts);
      cardWidget('fairSmallPromos', fairSmallPromosOpts);
      seoWidget('fairSeo', fairSeoOpts);
      gridGallerySmall('fairGridGallerySmall', fairGridGallerySmallOpts);
    } else {
      mainSlideshow();
      cardWidget('cardWidget', cardWidgetOpts);
      seoWidget('seoWidget', seoWidgetOpts);
      gridGallerySmall('gridGallerySmall', gridGallerySmallOpts);
    }
    staticManagedSponsors();
    scrollerSponsors();
  });
}

// Initialize Ticket Button Widget
$(document).ready(function () {
  if ($('body').hasClass('eventsMode')) {
    ticketButton();
  }
});
